export default "__VITE_ASSET__DnSxHXhi__"